import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader } from 'common/Card';
import { AUTHORIZATION_STATUSES } from 'common/Status/authorizationConstants';
import getAugmentedAuthorizationStatus from 'pages/service-authorizations/utils/getAugmentedAuthorizationStatus';
import authorizationShape from './authorizationShape';
import AuthorizationHistoryLineItem from './components/AuthorizationHistoryLineItem';
import AcceptedAuthorizationFields from './components/AcceptedAuthorizationFields';
import RequestedAuthorizationFields from './components/RequestedAuthorizationFields';
import VoidedAuthorizationFields from './components/VoidedAuthorizationFields';
import RejectedAuthorizationFields from './components/RejectedAuthorizationFields';
import { authorizationHistoryIcon, authorizationHistoryIconColor } from './utils';

const AuthorizationFieldsSection = ({ authorization }) => {
  const state = authorization.state;

  if (state === AUTHORIZATION_STATUSES.accepted) {
    return <AcceptedAuthorizationFields authorization={authorization} />;
  }

  if (state === AUTHORIZATION_STATUSES.void) {
    return <VoidedAuthorizationFields authorization={authorization} />;
  }

  if (state === AUTHORIZATION_STATUSES.rejected) {
    return <RejectedAuthorizationFields authorization={authorization} />;
  }

  const notesContent =
    state === AUTHORIZATION_STATUSES.open ? authorization.update_request_note : authorization.reviewer_note;

  return (
    <RequestedAuthorizationFields
      authorization={authorization}
      notesContent={notesContent}
    />
  );
};

AuthorizationFieldsSection.propTypes = {
  authorization: PropTypes.shape(authorizationShape).isRequired,
};

const AuthorizationHistoryCard = ({ authorization, lineage }) => {
  const state = authorization.state;
  const statusText = getAugmentedAuthorizationStatus(authorization, lineage);

  const icon = authorizationHistoryIcon[state];
  const color = authorizationHistoryIconColor[state];

  return (
    <Card className="px-2 py-2 bg-light-fill-grey">
      <CardHeader
        title={`Authorization Request #${authorization.short_id}`}
        titleIcon={icon}
        titleClassName="text-black text-base leading-6 font-semibold"
        iconColor={color}
        className="pt-2 space-y-2"
      />
      <dl className="m-0 px-4 py-6 grid grid-cols-4 gap-y-2 gap-x-12">
        <AuthorizationHistoryLineItem field="Status">
          {statusText}
        </AuthorizationHistoryLineItem>
        <AuthorizationFieldsSection
          authorization={authorization}
        />
      </dl>
    </Card>
  );
};

AuthorizationHistoryCard.propTypes = {
  authorization: PropTypes.shape(authorizationShape).isRequired,
  lineage: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default AuthorizationHistoryCard;
